import { useContext } from "react";
import { TabContext } from "./TabProvider";

/**
 * @deprecated TabUI instead
 */
export const useTab = () => {
  const context = useContext(TabContext);
  return context;
};
